import {Localizer} from "../../../../infrastructure/localization/localizer";
import {PdfDetailedUserHeaderComponent} from "./pdfDetailedUserHeaderComponent";
import PdfHeaderRow from "../components/pdfHeaderRow";
import { PdfBeskaeftigelseHeaderModel } from "../models/pdfBeskaeftigelseHeaderModel";

type PdfBeskaeftigelseHeaderComponentProps = {
    data: PdfBeskaeftigelseHeaderModel;
}

export function PdfBeskaeftigelseHeaderComponent({ data }: PdfBeskaeftigelseHeaderComponentProps) {
    return (
        <div className={"card shadow-none"}>
            <div className={"card-body flex-container-column flex-space"}>
                <PdfDetailedUserHeaderComponent bruger={data.bruger}/>
                <PdfHeaderRow>
                    <PdfHeaderRow.Entry
                        label={Localizer.global_speciale()}
                        value={data.speciale.navn}
                    />
                    <PdfHeaderRow.Entry
                        label={Localizer.global_maalbeskrivelse()}
                        value={data.maalbeskrivelseNavn}
                    />
                </PdfHeaderRow>
            </div>
        </div>
    );
}
